var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selector Right",
    clipPath: "url(#clip0_10595_43996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M0 0H34C35.1046 0 36 0.895431 36 2V34C36 35.1046 35.1046 36 34 36H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Next",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6571 18.1111C21.6571 18.2734 21.5884 18.4262 21.4705 18.5408L17.0705 22.8186C16.9527 22.9332 16.7955 23 16.6286 23C16.2848 23 16 22.7231 16 22.3889L16 13.8333C16 13.4991 16.2848 13.2222 16.6286 13.2222C16.7955 13.2222 16.9527 13.2891 17.0705 13.4036L21.4705 17.6814C21.5884 17.796 21.6571 17.9488 21.6571 18.1111Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10595_43996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.d58940182cfde85668cb76ab428900a6.svg";
export { ForwardRef as ReactComponent };